import { z } from 'zod';
import { booleanFilter, datetimeFilter, picklistFilter } from './common/filters';
import { itemFilterSearchSchema } from './itemFilterSearchSchema';

const emptyStringToUndefined = (v: unknown) => (v === '' ? undefined : v);

const compactPicklist = z.preprocess(
  emptyStringToUndefined,
  z.union([z.number(), z.string(), picklistFilter]).optional(),
);
const compactBoolean = z.preprocess(
  emptyStringToUndefined,
  z.union([z.boolean(), z.string(), booleanFilter]).optional(),
);
const compactDatetime = z.preprocess(
  emptyStringToUndefined,
  z.union([z.string(), datetimeFilter]).optional(),
);

export const itemFilterUrlSearchSchema = itemFilterSearchSchema.extend({
  effortEstimate: compactPicklist,
  estimationId: compactPicklist,
  itemTypeId: compactPicklist,
  parentId: compactPicklist,
  ancestorId: compactPicklist,
  id: compactPicklist,
  loopId: compactPicklist,
  statusId: compactPicklist,
  teamId: compactPicklist,
  integrationId: compactPicklist,
  objectiveId: compactPicklist,
  isUnparented: compactBoolean,
  isMLImputed: compactBoolean,
  needsTeamOrEstimate: compactBoolean,
  inDoneSubtree: compactBoolean,
  unresolved: compactBoolean,
  hasObjective: compactBoolean,
  hasDependencies: compactBoolean,
  hasPredecessor: compactBoolean,
  hasSuccessor: compactBoolean,
  hasEstimate: compactBoolean,
  noEstimate: compactBoolean,
  createdAt: compactDatetime,
  forecastedFinishDateTime: compactDatetime,
  forecastedStartDateTime: compactDatetime,
  latestFinishDateTime: compactDatetime,
  doneDateTime: compactDatetime,
  plannedStartDateTime: compactDatetime,
  plannedFinishDateTime: compactDatetime,
  deadlineDateTime: compactDatetime,
  earliestStartDateTime: compactDatetime,
  updatedAt: compactDatetime,
});
